import React from "react";
import { Button, Container } from "react-bootstrap";

const NAVY = "#1a237e";

const KNOCKOUT_MATCHES = [
  // Quarter Finals
  {
    matchNo: "Match-42",
    date: "9 April, 2026",
    time: "7:00 AM IST",
    pitch: "Pitch 1",
    stage: "QF 1",
    teamA: "Hockey Chandigarh",
    teamB: "Dadra & Nagar Haveli And Daman & Diu Hockey",
    scoreA: 1,
    scoreB: 2,
  },
  {
    matchNo: "Match-43",
    date: "9 April, 2026",
    time: "9:00 AM IST",
    pitch: "Pitch 1",
    stage: "QF 2",
    teamA: "Hockey Jharkhand",
    teamB: "Hockey Punjab",
    scoreA: 3,
    scoreB: 5,
  },
  {
    matchNo: "Match-44",
    date: "9 April, 2026",
    time: "11:00 AM IST",
    pitch: "Pitch 1",
    stage: "QF 3",
    teamA: "Uttar Pradesh Hockey",
    teamB: "Hockey Association of Odisha",
    scoreA: 6,
    scoreB: 3,
  },
  {
    matchNo: "Match-45",
    date: "9 April, 2026",
    time: "16:00 PM IST",
    pitch: "Pitch 1",
    stage: "QF 4",
    teamA: "Hockey Madhya Pradesh",
    teamB: " Hockey Haryana ",
    scoreA: 4,
    scoreB: 3,
  },
  // Semi Finals
  {
    matchNo: "Match-46",
    date: "10 April, 2026",
    time: "10:00 AM IST",
    pitch: "Pitch 1",
    stage: "SF 1",
    teamA: "Dadra & Nagar Haveli And Daman & Diu Hockey",
    teamB: "Hockey Madhya Pradesh",
    scoreA: 2,
    scoreB: 4,
  },
  {
    matchNo: "Match-47",
    date: "10 April, 2026",
    time: "16:00 PM IST",
    pitch: "Pitch 1",
    stage: "SF 2",
    teamA: "Hockey Punjab",
    teamB: "Uttar Pradesh Hockey",
    scoreA: 2,
    scoreB: 6,
  },
  // 3rd/4th Place
  {
    matchNo: "Match-48",
    date: "12 April, 2026",
    time: "10:00 AM IST",
    pitch: "Pitch 1",
    stage: "3/4TH",
    teamA: "Dadra & Nagar Haveli And Daman & Diu Hockey",
    teamB: "Hockey Punjab",
    scoreA: 0,
    scoreB: 1,
  },
  // Final
  {
    matchNo: "Match-49",
    date: "12 April, 2026",
    time: "16:00 PM IST",
    pitch: "Pitch 1",
    stage: "FINAL",
    teamA: "Hockey Madhya Pradesh",
    teamB: "Uttar Pradesh Hockey",
    scoreA: 2,
    scoreB: 5,
  },
];

const STAGE_ORDER = [
  "QF 1",
  "QF 2",
  "QF 3",
  "QF 4",
  "SF 1",
  "SF 2",
  "3/4TH",
  "FINAL",
];

function KnockoutCard({ match }) {
  const isSpecial = match.stage === "FINAL" || match.stage === "3/4TH";
  return (
    <div
      style={{
        background: "#fff",
        border: `1.5px solid ${isSpecial ? NAVY : "#e0e3f0"}`,
        borderRadius: "12px",
        padding: "16px 18px 10px",
        marginBottom: "12px",
      }}
    >
      {/* Teams + score row */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: "8px",
        }}
      >
        {/* Team A */}
        <div
          style={{ display: "flex", alignItems: "center", gap: "8px", flex: 1 }}
        >
          <div
            style={{
              width: "34px",
              height: "34px",
              borderRadius: "50%",
              background: NAVY,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexShrink: 0,
            }}
          >
            <svg width="18" height="18" viewBox="0 0 24 24" fill="white">
              <circle cx="12" cy="8" r="4" />
              <path d="M4 20c0-4 3.6-7 8-7s8 3 8 7" />
            </svg>
          </div>
          <span
            style={{
              fontWeight: 700,
              fontSize: "11px",
              color: NAVY,
              textTransform: "uppercase",
              lineHeight: 1.2,
            }}
          >
            {match.teamA}
          </span>
        </div>

        {/* Score */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "6px",
            flexShrink: 0,
          }}
        >
          <span style={{ fontWeight: 900, fontSize: "18px", color: NAVY }}>
            {match.scoreA ?? 0}
          </span>
          <span
            style={{
              fontWeight: 700,
              fontSize: "13px",
              color: NAVY,
              fontStyle: "italic",
            }}
          >
            VS
          </span>
          <span style={{ fontWeight: 900, fontSize: "18px", color: NAVY }}>
            {match.scoreB ?? 0}
          </span>
        </div>

        {/* Team B */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
            flex: 1,
            justifyContent: "flex-end",
          }}
        >
          <span
            style={{
              fontWeight: 700,
              fontSize: "11px",
              color: NAVY,
              textTransform: "uppercase",
              lineHeight: 1.2,
              textAlign: "right",
            }}
          >
            {match.teamB}
          </span>
          <div
            style={{
              width: "34px",
              height: "34px",
              borderRadius: "50%",
              background: NAVY,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexShrink: 0,
            }}
          >
            <svg width="18" height="18" viewBox="0 0 24 24" fill="white">
              <circle cx="12" cy="8" r="4" />
              <path d="M4 20c0-4 3.6-7 8-7s8 3 8 7" />
            </svg>
          </div>
        </div>
      </div>

      {/* Meta row */}
      <div
        style={{
          marginTop: "10px",
          paddingTop: "8px",
          borderTop: "1px solid #e8eaf6",
          display: "flex",
          flexWrap: "wrap",
          gap: "14px",
          fontSize: "11px",
          color: "#555",
        }}
      >
        <span>
          <strong style={{ color: NAVY }}>{match.matchNo}</strong>
        </span>
        <span>📅 {match.date}</span>
        <span>🕐 {match.time}</span>
        <span>📍 {match.pitch}</span>
        <span>👥 {match.stage}</span>
      </div>
    </div>
  );
}

export default function SubJuniorMensHockeyKnockout() {
  return (
    <div
      style={{
        minHeight: "100vh",
        backgroundImage: "url('/img/bghockyimg.jpeg')",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundAttachment: "fixed",
        backgroundRepeat: "no-repeat",
      }}
    >
      {/* ← Return */}
      <div style={{ padding: "16px 20px", textAlign: "left" }}>
        <Button
          href="/sub-junior-mens-hockey-2026"
          style={{
            backgroundColor: NAVY,
            borderColor: NAVY,
            fontSize: "12px",
            padding: "6px 16px",
          }}
        >
          ← Return
        </Button>
      </div>

      <Container style={{ maxWidth: "960px", paddingBottom: "60px" }}>
        <h1
          style={{
            color: NAVY,
            fontWeight: 900,
            fontSize: "clamp(22px, 4vw, 36px)",
            textAlign: "center",
            textTransform: "uppercase",
            letterSpacing: "1px",
            marginBottom: "28px",
          }}
        >
          Knockout
        </h1>

        <div
          style={{
            display: "grid",
            gridTemplateColumns:
              "repeat(auto-fill, minmax(min(100%, 420px), 1fr))",
            gap: "0 16px",
          }}
        >
          {STAGE_ORDER.map((stage) => {
            const match = KNOCKOUT_MATCHES.find((m) => m.stage === stage);
            return match ? (
              <KnockoutCard key={match.matchNo} match={match} />
            ) : null;
          })}
        </div>
      </Container>
    </div>
  );
}
